import { Component, OnInit, ChangeDetectorRef, HostListener, OnDestroy } from '@angular/core';
import { DataSharingService } from './common/services/data-sharing.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '../../node_modules/@angular/router';
import { PermissionService } from './security/permission.service';
import { SessionHelper } from './common/helpers/session.helper';
import { EmployeeService } from './crm/services/employee.service';
import { Favicons } from './favicon.service';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var window: any;
declare var navigator: any;
declare var opera: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy {
  public showLoader: boolean = false;
  private favicons: Favicons;
  private unsubscribe$ = new Subject<void>();

  constructor(private employeeService: EmployeeService, private dataSharingService: DataSharingService,
    private permissionService: PermissionService, private _router: Router,
    private _route: ActivatedRoute, favicons: Favicons,
    private titleService: Title, modalService: NgbModal) {
    this.favicons = favicons;
  }

  ngOnInit() {
    this.useFavicon();
    try {
      this.dataSharingService.getShowLoader()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          async (data) => { this.showLoader = await data }
        );

      /////////////start To reload current route 
      this._router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };

      this._router.events
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((evt: any) => {
          if (evt instanceof NavigationStart) {
            this.checkIsUserDeleted();
          }
          if (evt instanceof NavigationEnd) {
            this._router.navigated = false;
            window.scrollTo(0, 0);
            this.permissionService.updatedCurrentURL(this._router.url);
            // this.modalService.dismissAll(); 
            // if ($('.modal')) {
            //   $('.modal').remove();
            //   $('.modal-backdrop').remove();
            //   $('body').removeClass("modal-open");
            // }
          }
        });
      /////////end
    }
    catch (ex) {
    }
  }

  setUserDetails() {
    try {
      this.employeeService.getMyCompanyProfile(SessionHelper.getAuthenticationId())
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          res => {
            this.employeeService.setUserProfileDetail(res);
          },
          error => {
          }
        )
    } catch (ex) {
    }
  }

  isPhone(): boolean {
    if (typeof window === `undefined` || typeof navigator === `undefined`) return false;

    return /iPhone/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`));
  }

  //   doBeforeUnload() {
  //     // Alert the user window is closing 
  //     alert("hello");
  //     return false;
  // }

  checkIsUserDeleted() {
    try {
      this.employeeService.checkIsUserDeleted(SessionHelper.getUserId(), SessionHelper.getUserType())
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          res => {
            if (res.IsUserDeleted) {
              SessionHelper.clearSession();
              this._router.navigateByUrl('/auth/login');
            }
          },
          error => {
          }
        )
    } catch (ex) {
    }
  }

  private useFavicon(): void {
    const currentHostName = window.location.hostname;
    if (currentHostName == 'myhomeroadmap.com') {
      this.titleService.setTitle('The Home Roadmap');
      this.favicons.activate('home-roadmap');
    }
    else if (currentHostName == "creditrepairupdate.com") {
      this.titleService.setTitle('Credit Repair Update');
      this.favicons.activate('credit-repair-update');
    }
    else if (currentHostName == "creditaugmentor.com") {
      this.titleService.setTitle('The Credit Augmentor');
      this.favicons.activate('credit-augmentor');
    } else if (currentHostName == "mycreditupclub.com") {
      this.titleService.setTitle('The CreditUp Club');
      this.favicons.activate('creditup-club');
    } else {
      this.titleService.setTitle('The Credit Repairmen');
      this.favicons.activate('credit-repair-update');
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/app.component.ts